import type {PromotionCycle} from '../../../../types';

import {ClockCircleOutlined, EditOutlined} from '@ant-design/icons';
import {Card} from '@ds/components';

import {formatPromotionDateRange} from '../../../../utils';
import StockAvailability from '../../../common/StockAvailability/StockAvailability';

type EditableDiscountCardProps = {
  cycle: PromotionCycle;
  onClick: () => void;
};

const EditableDiscountCard: React.FC<EditableDiscountCardProps> = ({cycle, onClick}) => {
  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const remainingDays = Math.max(
    0,
    Math.ceil((new Date(cycle.discount_start_date).getTime() - Date.now()) / millisecondsPerDay)
  );
  const date = formatPromotionDateRange(cycle.discount_start_date, cycle.discount_end_date);

  return (
    <Card
      className="w-full cursor-pointer border-gray-22 shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange [&>div]:p-3"
      size="small"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-3">
          <div className="flex flex-col">
            <h3 className="text-body-sm-emphasis text-neutral-fg">{date}</h3>
            <span className="flex items-center gap-1 text-body-sm text-gray-07">
              <span>{cycle.product_count ?? 0} کالا</span>
              <span>•</span>
              <ClockCircleOutlined aria-hidden />
              <span>{remainingDays} روز تا شروع</span>
            </span>
          </div>
          <EditOutlined className="text-subtitle-lg text-orange" aria-hidden />
        </div>
        <div className="mx-5 my-2.5">
          <StockAvailability stockAvailability={cycle.stock_availability} />
        </div>
      </div>
    </Card>
  );
};

export default EditableDiscountCard;
